import { fetchApi } from "./apiClient";

export const getNotifications = async ({ page = 1, limit = 10 }) => {
    return fetchApi(`/user/notifications?page=${page}&limit=${limit}&action=all`, "GET", null, { showErrorToast: false });
};

export const markAllNotificationsAsRead = async () => {
    return fetchApi(`/user/notifications?action=mark_all_as_read`, "GET", null, { showErrorToast: false });
};

export const markNotificationAsRead = async (notificationId) => {
    return fetchApi(`/user/notifications?action=by_id&notificationId=${notificationId}`, "GET", null, { showErrorToast: false });
};
